import React from "react";
import { Grid, Typography } from "e100-react-components";
import { IconBattery } from "./IconBattery";

interface DeviceBatteryProps {
  batteryCharge: number;
}

export const DeviceBattery = ({ batteryCharge }: DeviceBatteryProps) => {
  return (
    <Grid container alignItems="flex-start">
      <Grid item>
        <IconBattery batteryCharge={batteryCharge} />
      </Grid>
      <Grid item>
        <Typography variant="subtitle2" color="textSecondary">
          {batteryCharge}%
        </Typography>
      </Grid>
    </Grid>
  );
};
